<template>
  <v-dialog
    v-model="show"
    content-class="content-dialog-box"
    :max-width="maxWidth"
    persistent
  >
    <v-card class="standard-modal">
      <v-card-title v-if="title" class="text-h6">
        <span class="secondary--font font-weight-600"> {{ title }} </span>
      </v-card-title>
      <v-card-subtitle v-if="subtitle" class="body-2">
        <span v-html="subtitle"></span>
      </v-card-subtitle>
      <v-card-subtitle
        class="black--text font-weight-medium"
        v-if="message"
        :class="{ 'delete-warning': type == 'warning' }"
      >
        <span v-html="message"></span>
        <img v-if="image != null" :src="require(`../../assets/images/${image}`)" height="100px" width="100%">
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer />
        <v-btn v-if="cancelBtn" v-track="'action-cancel'" text class="font-weight-bold" @click="cancel">
          {{ cancelText }}
        </v-btn>
        <v-btn
          v-if="confirmBtn"
          v-track="'action-confirmed'"
          class="font-weight-bold"
          :loading="loading"
          dark
          @click="$emit('confirm', $event, data)"
          :disabled="!confirmEnabled"
        >
          {{ confirmationText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "DialogBox",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
    confirmationText: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 500,
    },
    confirmBtn: {
      type: Boolean,
      default: false,
    },
    confirmEnabled: {
      type: Boolean,
      default: true,
    },
    cancelBtn: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object | String | Number | Array,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped lang="scss">
.content-dialog-box {
  .delete-warning {
    font-size: 15px !important;
    color: #423939;
  }
}
.standard-modal {
  padding: 32px 32px 0px 32px !important;
  & .v-card__title {
    margin: 0px !important;
    padding: 0px !important;
    &h4 {
      margin-bottom: 0px !important;
    }
  }
  & .v-card__subtitle.only-top-padding {
    padding: 16px 0px 0px 0px !important;
  }
  & .v-card__subtitle {
    margin: 0px !important;
    padding: 10px 0px 5px 0px !important;
  }
  & .v-card__actions {
    padding: 24px 0px 24px 0px !important;
  }
  & .v-input--checkbox {
    padding: 16px 0px 0px 0px !important;
    margin-top: 0px;
  }
  & .v-input--checkbox.no-checkbox-padding {
    padding: 0px 0px 0px 0px !important;
  }
  & .v-text-field {
    padding: 16px 0px 0px 0px !important;
  }
  & .inner-padding {
    padding: 16px 0px 0px 0px !important;
  }
  & .v-input--radio-group {
    padding: 16px 0px 0px 0px !important;
    margin-top: 0px !important;
  }
}
</style>
